var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      attrs: {
        "grid-list-xl": "",
        "text-center": "",
        "aria-label": "Settings Section",
      },
    },
    [
      _c(
        "v-layout",
        { attrs: { wrap: "" } },
        [
          _c(
            "v-flex",
            {
              attrs: {
                xs12: "",
                sm12: "",
                md12: "",
                lg6: "",
                "offset-lg3": "",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-app-bar",
                    {
                      attrs: { flat: "", color: "primary", role: "navigation" },
                    },
                    [
                      _c("h1", { staticClass: "text-body-2" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("components.settings.title")) +
                            "\n          "
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-container",
                    { attrs: { fluid: "", "grid-list-md": "" } },
                    [
                      _vm._l(
                        _vm.filteredErrors,
                        function (errorsGroup, errorsGroupIndex) {
                          return _c(
                            "div",
                            {
                              key: errorsGroupIndex,
                              attrs: {
                                role: "group",
                                "aria-labelledby": "settings-errors-label",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "sr-only",
                                  attrs: { id: "settings-errors-label" },
                                },
                                [_vm._v("Validation errors")]
                              ),
                              _vm._v(" "),
                              _vm._l(errorsGroup, function (error) {
                                return _c(
                                  "v-alert",
                                  {
                                    key: error.id,
                                    attrs: {
                                      type: error.type,
                                      icon: error.icon,
                                      role: "alert",
                                      "aria-live": "assertive",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(error.msg) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          )
                        }
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  disabled:
                                    _vm.isLoadingOrdersNotification ||
                                    _vm.isLoading,
                                  color: _vm.hasOrdersEmailNotification
                                    ? "accent"
                                    : "primary",
                                  "aria-label": _vm.$t(
                                    "components.settings.ordersLabelEnabled"
                                  ),
                                  "aria-checked":
                                    _vm.hasOrdersEmailNotification,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.hasOrdersEmailNotification
                                                ? _vm.$t(
                                                    "components.settings.ordersLabelEnabled"
                                                  )
                                                : _vm.$t(
                                                    "components.settings.ordersLabelDisabled"
                                                  )
                                            ) +
                                            "\n                  "
                                        ),
                                        _c("v-progress-circular", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.isLoadingOrdersNotification,
                                              expression:
                                                "isLoadingOrdersNotification",
                                            },
                                          ],
                                          staticClass: "ml-2",
                                          attrs: {
                                            indeterminate:
                                              _vm.isLoadingOrdersNotification,
                                            color: "accent",
                                            value: 0,
                                            size: "24",
                                            "aria-hidden": "true",
                                            role: "presentation",
                                          },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                                model: {
                                  value: _vm.hasOrdersEmailNotification,
                                  callback: function ($$v) {
                                    _vm.hasOrdersEmailNotification = $$v
                                  },
                                  expression: "hasOrdersEmailNotification",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  disabled:
                                    _vm.isLoadingAuthenticatedNotification ||
                                    _vm.isLoading,
                                  color: _vm.hasAuthenticatedEmailNotification
                                    ? "accent"
                                    : "primary",
                                  "aria-label": _vm.$t(
                                    "components.settings.authLabelEnabled"
                                  ),
                                  "aria-checked":
                                    _vm.hasAuthenticatedEmailNotification,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.hasAuthenticatedEmailNotification
                                                ? _vm.$t(
                                                    "components.settings.authLabelEnabled"
                                                  )
                                                : _vm.$t(
                                                    "components.settings.authLabelDisabled"
                                                  )
                                            ) +
                                            "\n                  "
                                        ),
                                        _c("v-progress-circular", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.isLoadingAuthenticatedNotification,
                                              expression:
                                                "isLoadingAuthenticatedNotification",
                                            },
                                          ],
                                          staticClass: "ml-2",
                                          attrs: {
                                            indeterminate:
                                              _vm.isLoadingAuthenticatedNotification,
                                            color: "accent",
                                            value: 0,
                                            size: "24",
                                            "aria-hidden": "true",
                                            role: "presentation",
                                          },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                                model: {
                                  value: _vm.hasAuthenticatedEmailNotification,
                                  callback: function ($$v) {
                                    _vm.hasAuthenticatedEmailNotification = $$v
                                  },
                                  expression:
                                    "hasAuthenticatedEmailNotification",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  disabled:
                                    _vm.isLoadingGiftsNotifications ||
                                    _vm.isLoading,
                                  color: _vm.hasGiftsNotifications
                                    ? "accent"
                                    : "primary",
                                  "aria-label": _vm.$t(
                                    "components.settings.giftsLabelEnabled"
                                  ),
                                  "aria-checked": _vm.hasGiftsNotifications,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.hasGiftsNotifications
                                                ? _vm.$t(
                                                    "components.settings.giftsLabelEnabled"
                                                  )
                                                : _vm.$t(
                                                    "components.settings.giftsLabelDisabled"
                                                  )
                                            ) +
                                            "\n                  "
                                        ),
                                        _c("v-progress-circular", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.isLoadingGiftsNotifications,
                                              expression:
                                                "isLoadingGiftsNotifications",
                                            },
                                          ],
                                          staticClass: "ml-2",
                                          attrs: {
                                            indeterminate: true,
                                            color: "accent",
                                            size: "24",
                                            "aria-hidden": "true",
                                            role: "presentation",
                                          },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                                model: {
                                  value: _vm.hasGiftsNotifications,
                                  callback: function ($$v) {
                                    _vm.hasGiftsNotifications = $$v
                                  },
                                  expression: "hasGiftsNotifications",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  disabled:
                                    _vm.isLoadingMarketingNews || _vm.isLoading,
                                  color: _vm.hasMarketingNews
                                    ? "accent"
                                    : "primary",
                                  "aria-label": _vm.$t(
                                    "components.settings.marketingNewsLabelEnabled"
                                  ),
                                  "aria-checked": _vm.hasMarketingNews,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.hasMarketingNews
                                                ? _vm.$t(
                                                    "components.settings.marketingNewsLabelEnabled"
                                                  )
                                                : _vm.$t(
                                                    "components.settings.marketingNewsLabelDisabled"
                                                  )
                                            ) +
                                            "\n                  "
                                        ),
                                        _c("v-progress-circular", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.isLoadingMarketingNews,
                                              expression:
                                                "isLoadingMarketingNews",
                                            },
                                          ],
                                          staticClass: "ml-2",
                                          attrs: {
                                            indeterminate:
                                              _vm.isLoadingMarketingNews,
                                            color: "accent",
                                            value: 0,
                                            size: "24",
                                            "aria-hidden": "true",
                                            role: "presentation",
                                          },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                                model: {
                                  value: _vm.hasMarketingNews,
                                  callback: function ($$v) {
                                    _vm.hasMarketingNews = $$v
                                  },
                                  expression: "hasMarketingNews",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c("v-progress-linear", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isLoading || _vm.isLoadingDeactivateUser,
                            expression: "isLoading || isLoadingDeactivateUser",
                          },
                        ],
                        attrs: {
                          color: "accent",
                          indeterminate: "",
                          role: "progressbar",
                          "aria-label": "Loading settings",
                          "aria-valuenow": undefined,
                          "aria-valuemin": "0",
                          "aria-valuemax": "100",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "error",
                            type: "button",
                            text: "",
                            disabled:
                              _vm.isLoading || _vm.isLoadingDeactivateUser,
                            "aria-label": "Deactivate account",
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.setDialogVisiblity()
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v(
                              "\n              fal fa-user-alt-slash\n            "
                            ),
                          ]),
                          _vm._v(
                            _vm._s(_vm.$t("components.settings.deactivate")) +
                              "\n          "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-dialog",
                        {
                          attrs: {
                            transition: "dialog-bottom-transition",
                            fullscreen: _vm.$vuetify.breakpoint.mdAndDown
                              ? true
                              : false,
                            width: _vm.$vuetify.breakpoint.mdAndDown
                              ? "auto"
                              : "500",
                            role: "dialog",
                            "aria-modal": "true",
                            "aria-labelledby": "deactivate-title",
                          },
                          model: {
                            value: _vm.isDialogVisible,
                            callback: function ($$v) {
                              _vm.isDialogVisible = $$v
                            },
                            expression: "isDialogVisible",
                          },
                        },
                        [
                          _c(
                            "v-card",
                            [
                              _c(
                                "v-card-title",
                                {
                                  staticClass: "h5",
                                  attrs: { id: "deactivate-title" },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "components.settings.dialog.title"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-card-text", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "components.settings.dialog.description"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-card-actions",
                                [
                                  _c("div", { staticClass: "flex-grow-1" }),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        "aria-label": _vm.$t(
                                          "components.settings.dialog.no"
                                        ),
                                        color: "primary",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.setDialogVisiblity()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "components.settings.dialog.no"
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "accent--text",
                                      attrs: {
                                        "aria-label": _vm.$t(
                                          "components.settings.dialog.confirm"
                                        ),
                                        color: "primary",
                                        text: "",
                                        autofocus: true,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.ChangeDeactivatedUser()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "components.settings.dialog.confirm"
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }